module.exports = "pegasus/assets/preview-19.png";